<template>
    <div class="item"
        @click="active ? $emit('click', $event) : $emit('config', item)">
        <img class="__icon" :src="'data:image/png;base64,'+item.small_image">
        <h5>{{item.caption}}</h5>

      <div class="label" v-if="!active">inactive</div>
	    <div class="settings" v-else @click.prevent="$emit('config', item)"
	         v-tippy="{theme:'small-black'}" content="Configure this integration">
		    <inline-svg :src="require('@/assets/img/settings.svg')" />
	    </div>

        <v-button
            v-if="!active"
            @click.prevent="$emit('config', item)"
        >Click to activate</v-button>
    </div>
</template>

<script>
import VButton from "@/components/base/v-button";

export default {
  components: {
      VButton,
  },
  props: ['item'],
	computed: {
		active() {
			return this.item.user_integration.active;
		}
	}
}
</script>
<style lang="scss" scoped>
.item {
	width: 138px;
	margin: 0;
	background: #FFFFFF;
	padding: 10px;
	text-align: center;
	border: 2px solid #E4E6F1;
	border-radius: 6px;
	position: relative;
	overflow: hidden;
	cursor: pointer;

	&.active {
		background-color: #F6F9FE;
	}
	&:hover {
		border-color: #4368e0;
		.btn {
			opacity: 1;
		}
	}

	h5 {
		margin-top: 8px;
		font-size: 13px;
		line-height: 150%;
		text-align: center;
		letter-spacing: 0.02em;
		color: #636A7B;
		font-weight: 400;
	}

	.btn, .button {
		position: absolute;
		opacity: 0;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 12px;
		padding: 6px 5px;
		width: 90%;
		transition: 0.2s;
		max-width: 110px;
		z-index: 3;
	}

	.label {
		background: #E4E6F1;
		border-radius: 0 0 8px 0;
		padding: 5px 10px;
		font-weight: 500;
		font-size: 10px;
		line-height: 150%;
		text-align: center;
		letter-spacing: 0.02em;
		color: #252A32;
		position: absolute;
		top: 0;
		text-transform: uppercase;
		left: 0;
		z-index: 1;
	}
	.__icon {
		height: 30px;
		width: 30px;
		object-fit: scale-down;
	}
	.settings {
		background: #E4E6F1;
		border-radius: 0 0 8px 0;
		padding: 5px 10px;
		font-weight: 500;
		font-size: 10px;
		line-height: 150%;
		text-align: center;
		letter-spacing: 0.02em;
		color: #51565f;
		position: absolute;
		top: 0;
		text-transform: uppercase;
		left: 0;
		z-index: 1;
		> svg {
			height: 14px;
		}
		&:hover {
			background: #d0d2d8;
			//color: white;
		}
	}

}
</style>
